<template>
  <div
    v-if="!isToggleClose"
    class="flex flex-col w-full gap-3 p-4 sm:p-6 rounded-lg shadow-lg transition-all bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200 shadow-blue-gray-900/5"
  >
    <div role="alert" data-dismissible="alert" class="relative flex w-full">
      <div class="mr-10">
        <h3
          class="text-[clamp(1rem,2vw,1.5rem)] font-semibold leading-snug tracking-wide dark:text-gray-200"
        >
          A Big Welcome to HiSell!
        </h3>
        <p
          class="mt-2 text-[clamp(0.875rem,1.5vw,1rem)] leading-6 opacity-90 text-gray-800 dark:text-gray-300"
        >
          We’re excited that you’re taking these bold steps with us. We’ve
          automated most tasks, so you won’t need to do much, and we promise to
          work alongside you to make your business even bigger and better than
          before.
        </p>
      </div>
      <button
        @click="toggleClose"
        aria-label="Close alert"
        class="absolute top-3 right-3 flex items-center justify-center h-8 w-8 rounded-lg transition-all bg-gray-100 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200"
      >
        <i class="fa-solid fa-xmark text-[clamp(1rem,1.5vw,1.125rem)]"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartupWelcomeMessage",
  data() {
    return {
      userId: this.$store.state.selectedStore?.id,
      isToggleClose: this.$store.getters.hasSeenWelcomeMessage || false,
    };
  },
  methods: {
    toggleClose() {
      this.isToggleClose = !this.isToggleClose;
      localStorage.setItem(`${this.userId}welcomeMessage`, this.isToggleClose);
    },
  },
};
</script>
<style scoped>
@media (prefers-color-scheme: dark) {
  div {
    transition:
      background-color 0.3s ease,
      color 0.3s ease;
  }
}
</style>
